<template>
  <div class="p-6">
    <SurveyList
      v-if="!showForm"
      :surveys="surveys"
      @create="openForm($event.survey)"
      @edit="openForm"
      @delete="deleteSurvey"
    />

    <SurveyForm
      v-else
      :survey="currentSurvey"
      @saved="closeForm"
      @cancel="closeForm"
    />
  </div>
</template>

<script>
import SurveyList from '@/components/survey/SurveyList.vue';
import SurveyForm from '@/components/survey/SurveyForm.vue';
import repository from '../api/repository';

export default {
  components: { SurveyList, SurveyForm },
  data() {
    return {
      surveys: [],
      showForm: false,
      currentSurvey: null
    };
  },
  async mounted() {
    document.title = 'الاستبيانات';
    await this.loadSurveys();
  },
  methods: {
    async loadSurveys() {
      const res = await repository.index('surveys')
      console.log({
        res
      })
      this.surveys =  res.data.data;
    },
    openForm(survey = null) {
      console.log({
        survey
      })
      this.currentSurvey = survey;
      this.showForm = true;
    },
    closeForm() {
      this.showForm = false;
      this.currentSurvey = null;
      this.loadSurveys();
    },
    async deleteSurvey(id) {
      if (!confirm('هل أنت متأكد من حذف هذا الاستبيان؟')) return;
      
      await repository.destroy('surveys', id)

      await this.loadSurveys();
    }
  }
};
</script>
